export const EXTRA_FEATURES = {
  VARIANTS_DISPLAY: 'Variants display'
};
export const VARIANTS_DISPLAY_EXTRA_FEE_5K_PRODUCTS = 29;
export const VARIANTS_DISPLAY_EXTRA_FEE_10K_PRODUCTS = 49;
